import React, { useState, useContext, useEffect } from 'react';
import AuthContext from './AuthContext';

const Register = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [message, setMessage] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true); // State for submit button
    const [isRep, setIsRep] = useState(false);
    const { register } = useContext(AuthContext);

    useEffect(() => {
        // Check if all fields are filled
        if (username && password && email && firstName && lastName) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    }, [username, password, email, firstName, lastName]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await register(username, email, firstName, lastName, password, isRep);
        setMessage(result);
        setUsername('');
        setPassword('');
        setEmail('');
        setFirstName('');
        setLastName('');
        setIsRep(false);
    };

    return (
        <div style={styles.container}>
            {message && (
                <div style={styles.messageBox}>
                    <p>{message}</p>
                    <button onClick={() => setMessage('')} style={styles.closeButton}>Close</button>
                </div>
            )}
            <div style={styles.formContainer}>
                <h2 style={styles.title}>Register with RxAI</h2>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>First Name</label>
                        <input
                            type="text"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Last Name</label>
                        <input
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.toggleContainer}>
                    <label style={styles.toggleLabel}>
                        <input
                        type="checkbox"
                        checked={isRep}
                        onChange={() => setIsRep(!isRep)}
                        style={styles.checkbox}
                        />
                        Registering as a Rep
                    </label>
                    </div>
                    <button type="submit"
                        style={{
                            ...styles.button,
                            backgroundColor: isButtonDisabled ? '#ccc' : '#007bff', // Grey out the button when disabled
                            cursor: isButtonDisabled ? 'not-allowed' : 'pointer', // Change cursor to indicate it's not clickable
                        }}
                        disabled={isButtonDisabled}
                    >
                    Register
                </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f2f5',
        position: 'relative',
    },
    formContainer: {
        backgroundColor: '#fff',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
    },
    title: {
        marginBottom: '30px',
        fontSize: '1.8em',
        textAlign: 'center',
        color: '#333',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formGroup: {
        marginBottom: '15px',
    },
    label: {
        marginBottom: '5px',
        fontSize: '1em',
        color: '#333',
    },
    input: {
        padding: '10px',
        fontSize: '1em',
        borderRadius: '4px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box',
    },
    button: {
        padding: '10px',
        fontSize: '1.2em',
        color: '#fff',
        backgroundColor: '#007bff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        marginTop: '20px',
    },
    messageBox: {
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#ffcccc',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        width: '80%',
        maxWidth: '400px',
    },
    closeButton: {
        marginTop: '10px',
        padding: '8px',
        fontSize: '1em',
        color: '#fff',
        backgroundColor: '#007bff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '100%',
    },
    toggleContainer: {
        marginTop: '10px',
        marginBottom: '10px',
        textAlign: 'left',
    },
    toggleLabel: {
        fontSize: '0.95em',
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    checkbox: {
        transform: 'scale(1.2)',
    }
};

export default Register;
